import api from '@/api'
import { objectTrim } from '@/utils'
import {
  SET_JSON_TEMPLATE_QUERY,
  SET_JSON_SEARCHING,
  SET_JSON_LIST,
} from './mutation-types'

const initQuery = () => ({
  cgId: '',
})

const state = {
  searching: false,
  initQuery: initQuery(),
  list: [],
  query: initQuery(),
}

const mutations = {
  [SET_JSON_TEMPLATE_QUERY](state, payload) {
    state.query = {
      ...state.query,
      ...payload,
    }
  },
  [SET_JSON_SEARCHING](state, payload) {
    state.searching = payload
  },
  [SET_JSON_LIST](state, payload) {
    state.list = payload
  },
}

const actions = {
  async getJsonTemplateList({ commit, state }) {
    try {
      let params = {
        ...objectTrim(state.query),
      }
      commit(SET_JSON_SEARCHING, true)
      let { data } = await api.deployApi.queryJsonFileTemplateConfigList(params)
      commit(SET_JSON_SEARCHING, false)
      commit(SET_JSON_LIST, data)
    } catch (error) {
      commit(SET_JSON_LIST, [])
    }
  },
  async initJsonTemplateList({ dispatch }) {
    await dispatch('setQuery', state.initQuery)
    await dispatch('getJsonTemplateList')
  },
  setQuery({ commit, dispatch }, payload) {
    commit(SET_JSON_TEMPLATE_QUERY, payload)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
